import React from "react";
import ParentComponent from "../ParentComponent";
import { AuthContext } from "../AuthContext";
import Utils from "../../Utils";
import ar from "../../locale";
import { NavLink } from "react-router-dom";

export default class FieldLayout extends ParentComponent {
  static contextType = AuthContext;

  constructor(props, context) {
    super(props, context);
    this.state = {
      user: context.user,
    };
  }

  componentDidMount() {}

  componentWillUnmount() {}

  updateState = () => {
    this.setState((prev) => {
      return { ...prev };
    });
  };

  renderPlayers = (player) => {
    let { position } = player;
    return (
      <div
        key={player.uid || player.key}
        className="position-absolute pad-5"
        style={{ top: position.y, left: position.x }}
      >
        <div className="player-holder">
          <div className="cnumber font-weight-bold">{player.number}</div>
          <img src={player.avatar} className="playersize" alt="player" />
          <div className="cnameplate">{player.name}</div>
        </div>
      </div>
    );
  };

  render() {
    let { formation, club } = this.props;
    let players = Utils.convetPropToArray(formation.players);
    return (
      <div className="cfield-sm-dim m-3">
        <div className="mb-2">
          <p className="mb-0">
            {formation.avatar && (
              <img
                src={formation.avatar}
                alt="avatar"
                className="avatarc rounded-circle"
                width="30"
                height="30"
              />
            )}
            {!formation.avatar && (
              <img
                src="/assets/images/blankuser.png"
                alt="avatar"
                className="avatarc rounded-circle"
                width="30"
                height="30"
              />
            )}
            <span className="pl-2 pr-2">{formation.name}</span>
          </p>
          <p className="mb-0">
            <NavLink to={"/clubs/formations/" + club.key + "/" + formation.key}>
              {ar.comments} - {formation.comments || 0}
            </NavLink>
            <span className="pl-3 pr-3">
              {!this.props.deleting && (
                <i
                  className="fa fa-trash text-danger cursor-pointer"
                  title={ar.delete}
                  onClick={this.props.onDelete}
                ></i>
              )}
              {this.props.deleting && (
                <span
                  className="d-inline-block spinner-border spinner-border-sm text-danger"
                  role="status"
                ></span>
              )}
            </span>
          </p>
          <div className="form-group mt-1">
            <input
              type="checkbox"
              ref={(e) => (this.featured = e)}
              onChange={this.props.onFeatured}
              defaultChecked={formation.featured}
              id={"id" + formation.key}
            />
            <label htmlFor={"id" + formation.key}>
              <span className="pr-3">{ar.mark_as_featured}</span>
            </label>
          </div>
        </div>
        <div className="cfield cfield-sm">
          {players.map(this.renderPlayers)}
        </div>
      </div>
    );
  }
}
